import { render, staticRenderFns } from "./key-contact-modal.vue?vue&type=template&id=1ce9124c"
import script from "./key-contact-modal.vue?vue&type=script&lang=js"
export * from "./key-contact-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ce9124c')) {
      api.createRecord('1ce9124c', component.options)
    } else {
      api.reload('1ce9124c', component.options)
    }
    module.hot.accept("./key-contact-modal.vue?vue&type=template&id=1ce9124c", function () {
      api.rerender('1ce9124c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/contact/components/key-contact-modal.vue"
export default component.exports